import { Timeline, Assessment, Business, AttachMoney } from '@mui/icons-material';
import { formatDate as formatDateUtil } from '../../utils/dateUtils';
import {
    DEFICIENCY_STATUSES as DEFICIENCY_STATUS_MAP,
    getDisplayStatusValue,
} from '../Deficiencies/constants';

export const REPORT_TYPES = [
    {
        id: 'PERIOD_ACTIVITY',
        label: 'Activity Summary',
        description: 'Status overview for project and companies',
        icon: Assessment,
    },
    {
        id: 'COMPANY_PERFORMANCE',
        label: 'Company Performance',
        description: 'Completion rates and cycle times by company',
        icon: Business,
    },
    {
        id: 'DEFERRED_COST',
        label: 'Deferred Cost',
        description: 'Financial exposure of open deficiencies',
        icon: AttachMoney,
    },
    {
        id: 'ACTIVITY_LOG',
        label: 'Activity Log',
        description: 'Detailed event history for audits',
        icon: Timeline,
    },
];

export const DEFICIENCY_STATUSES = Object.values(DEFICIENCY_STATUS_MAP).map(
    (status) => status.value
);

/**
 * Status configuration with display labels and colors
 * Used for consistent status display across reports (matches backend status enum)
 */
export const STATUS_CONFIG = [
    { key: 'submittedCount', label: 'Submitted', color: '#2196f3' },
    { key: 'acceptedCount', label: 'Accepted', color: '#2196f3' },
    { key: 'assignedCount', label: 'Assigned', color: '#ff9800' },
    { key: 'workCompletedCount', label: 'Work Completed', color: '#8bc34a' },
    { key: 'internallySignedOffCount', label: 'Internal Sign Off', color: '#00bcd4' },
    { key: 'completedCount', label: 'Completed', color: '#4caf50' },
    { key: 'rejectedCount', label: 'Rejected', color: '#f44336' },
];

export const DEFERRED_COST_OPTIONS = [
    { label: 'All Items', value: 'ALL' },
    { label: 'With Cost', value: 'WITH_COST' },
    { label: 'Without Cost', value: 'WITHOUT_COST' },
];

/**
 * Format currency values
 */
export const formatCurrency = (value) => {
    if (value === null || value === undefined) return '$0.00';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    }).format(value);
};

/**
 * Format date for display - uses centralized dateUtils
 */
export const formatDate = (dateString) => {
    return formatDateUtil(dateString, 'N/A');
};

/**
 * Format status values from backend (e.g., ACCEPTED) to display format (e.g., Accepted)
 */
export const formatStatusValue = (status) => {
    if (!status) return status;
    return getDisplayStatusValue(status);
};

/**
 * Get status color - handles both backend format (ACCEPTED) and display format (Accepted)
 */
export const getStatusColor = (status) => {
    // Normalize the status to display format first
    const normalizedStatus = formatStatusValue(status);

    const matchingStatus = Object.values(DEFICIENCY_STATUS_MAP).find(
        (statusConfig) => statusConfig.value === normalizedStatus
    );

    return matchingStatus?.color || '#757575';
};
